import { type Receipt, ReceiptSchema } from '../data/receipt';
import { createMultipleHandler } from '../helpers/fetch-wrapper';
import { storesBaseUrl as baseUrl, StoreScopedService } from './base';

export class ReceiptService extends StoreScopedService {
  getReceipts(storeId: string): Promise<Receipt[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/receipts`)
      .then(createMultipleHandler(ReceiptSchema));
  }

  // Engagement events are the onboarding timeline's "the owner actually used
  // this" signal, posted from the report pages the receipts feed.
  recordEngagement(
    storeId: string,
    eventType: string,
    payload?: Record<string, unknown>
  ): Promise<void> {
    return this.fetchWrapper
      .post(`${baseUrl}/${storeId}/events`, {
        event_type: eventType,
        payload,
      })
      .then(() => undefined);
  }
}
